import garantiesService from "./garantiesService";
import prestationService from "./prestationService";
import * as OPTIONS from "@/classes/parametrage/options";
import * as GARANTIES from "@/classes/parametrage/garanties";

export default {
  getPensionInvalidite(userInput, idOption = OPTIONS.OBLIGATION_STATUTAIRE) {
    var idGarantie = userInput.isContractuel ? GARANTIES.INVALIDITE_CONTRACTUELS : GARANTIES.INVALIDITE_TITULAIRES;
    return this.getInvalidite(userInput, idOption, idGarantie);
  },

  getInvalidite(userInput, idOption = OPTIONS.OBLIGATION_STATUTAIRE, idGarantie) {
    var result = {
      montant: 0,
      categorie1: 0,
      categorie2et3: 0,
      montantDe: 0,
      montantA: 0,
    };

    var plafondNet = prestationService.getPlafondNet(userInput);

    if (!userInput.isContractuel) {
      let optionInvaliditeRetraite = garantiesService.getParametragesGaranties(GARANTIES.TYPE_INVALIDITE, idGarantie, idOption, GARANTIES.INVALIDITE_RETRAITE);
      let invaliditeRetraiteTauxSalaire = optionInvaliditeRetraite.find((x) => x.idTypeRemuneration == GARANTIES.TIB_NBI).tauxOption;
      let invaliditeRetraiteTauxPrimes = optionInvaliditeRetraite.find((x) => x.idTypeRemuneration == GARANTIES.PRIMES_INDEMNITES).tauxOption;

      if (idOption <= OPTIONS.OBLIGATION_STATUTAIRE) {
        result.resteAChargeMontantDe = Math.floor((userInput.salaireBrut - userInput.primes) * 0.5);
        result.resteAChargeMontantA = Math.floor((userInput.salaireBrut - userInput.primes) * 0.75);
      } else {
        let partSalaire = invaliditeRetraiteTauxSalaire * (userInput.salaireBrut - userInput.primes);

        // TODO : décommenter pour "limiter au net"
        // if (partSalaire > plafondNet.salaire) {
        //   partSalaire = plafondNet.salaire;
        // }

        let partPrimes = invaliditeRetraiteTauxPrimes * userInput.primes;

        // TODO : décommenter pour "limiter au net"
        // if (partPrimes > plafondNet.primes) {
        //   partPrimes = plafondNet.primes;
        // }

        result.montantDe = Math.floor(partSalaire + partPrimes);
        result.resteAChargeMontantDe = Math.floor(plafondNet.total - result.montantDe);
      }
    } else {
      let optionCategorie1 = garantiesService.getParametragesGaranties(GARANTIES.TYPE_INVALIDITE, idGarantie, idOption, GARANTIES.CATEGORIE_1);
      let categorie1TauxSalaire = optionCategorie1.find((x) => x.idTypeRemuneration == GARANTIES.TIB_NBI).tauxOption;
      let categorie1TauxPrimes = optionCategorie1.find((x) => x.idTypeRemuneration == GARANTIES.PRIMES_INDEMNITES).tauxOption;
      let optionCategorie2et3 = garantiesService.getParametragesGaranties(GARANTIES.TYPE_INVALIDITE, idGarantie, idOption, GARANTIES.CATEGORIE_2_3);
      let categorie2et3TauxSalaire = optionCategorie2et3.find((x) => x.idTypeRemuneration == GARANTIES.TIB_NBI).tauxOption;
      let categorie2et3TauxPrimes = optionCategorie2et3.find((x) => x.idTypeRemuneration == GARANTIES.PRIMES_INDEMNITES).tauxOption;

      var categorie1 = categorie1TauxSalaire * (userInput.salaireBrut - userInput.primes) + categorie1TauxPrimes * userInput.primes;

      // TODO : décommenter pour "limiter au net"
      // if (categorie1 > plafondNet.total) {
      //   categorie1 = plafondNet.total;
      // }

      var categorie2et3 = categorie2et3TauxSalaire * (userInput.salaireBrut - userInput.primes) + categorie2et3TauxPrimes * userInput.primes;

      // TODO : décommenter pour "limiter au net"
      // if (categorie2et3 > plafondNet.total) {
      //   categorie2et3 = plafondNet.total;
      // }

      result.montant = Math.floor(categorie1 + categorie2et3);
      result.categorie1 = Math.floor(categorie1);
      result.resteAChargeCategorie1 = Math.floor(plafondNet.total - categorie1);
      result.categorie2et3 = Math.floor(categorie2et3);
      result.resteAChargeCategorie2et3 = Math.floor(plafondNet.total - categorie2et3);
    }

    return result;
  },
};
